import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Alert, Col, Container, Form, Input, Label, Row } from "reactstrap";
import { Alerts, Btn, H2, H6, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { EmailAddress, Href, Password, SignIn } from "../../utils/Constant";
import { URL_API } from "../../utils/helper/helpers";
import axios from "axios";

const Login = () => {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState({
    email: '',
    password: ''
  });

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, type, value } = e.target;
    setData({ ...data, [name]: value, });
  };

  const SimpleLoginHandle = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (data.email === "" && data.password === "") {
      toast.error("Please Enter valid email or password...!");
    } else {
      axios.post(`${URL_API}/login`, { ...data }).then(response => {
        if (response.data.success) {
          toast.success("Welcome to you")
          localStorage.setItem("login", JSON.stringify(response.data.token));
          localStorage.setItem('user', JSON.stringify(response.data.user));
          localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
          // window.dispatchEvent(new Event("storage"));
          navigate(`${process.env.PUBLIC_URL}/pages/samplepage`);
        }

      }).catch(error => {
        if (error.status === 401) {
          setError(true);
          toast.warning("Oups !!! Identifiant ou mot de passe incorrect");
        }

        if (error.status === 405) {
          setError(true);
          toast.warning("Oups !!! Identifiant ou mot de passe incorrect");
        }
      })

    }
  };
  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <div>
              <div>
                <Link className="logo text-center" to={Href}>
                  <Image className="img-fluid for-light" src={dynamicImage("login/logo2etsdetf.png")} width={150} alt="logo" />
                  <Image className="img-fluid for-dark" src={dynamicImage("login/logo2etsdetf.png")} width={150} alt="darkLogo" />
                </Link>
              </div>
              <div className="login-main">
                <Form className="theme-form" onSubmit={(e) => SimpleLoginHandle(e)} >
                  <H2 className="text-center">Connectez-vous au compte</H2>
                  <P className="text-center">{"Pour vous connecter, Entrez votre identifiant et votre mot de passe"}</P>
                  {
                    error && error == true ? (<div className="text-danger text-center mb-2">
                      Oups !! Identifiant ou mot de passe incorrect
                    </div>) : null
                  }
                  <div className="form-group">
                    <Label className="col-form-label">{EmailAddress}</Label>
                    <Input type="email" placeholder="example@gmail.com" value={data.email} name="email" onChange={changeHandler} />
                  </div>
                  <div className="form-group">
                    <Label className="col-form-label">{Password}</Label>
                    <div className="form-input position-relative">
                      <Input type={show ? "text" : "password"} placeholder="*********" onChange={changeHandler} value={data.password} name="password" />
                      <div className="show-hide" onClick={() => setShow(!show)}>
                        <span className="show"> </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-0 checkbox-checked">

                    <div className="text-end mt-3">
                      <Btn color="primary" block className="w-100" >
                        {SignIn}
                      </Btn>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
